import { render, staticRenderFns } from "./Annuaire.vue?vue&type=template&id=32f21321&"
import script from "./Annuaire.vue?vue&type=script&lang=js&"
export * from "./Annuaire.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports